import { ApiResponse } from './apiClient';

type BaseParamType = string | number | boolean | Date;
type ValidParamType = BaseParamType | BaseParamType[];
export type QueryParams = Record<string, ValidParamType | undefined | null>;

export const createQueryString = (params?: QueryParams): string => {
    if (!params) return '';

    const entries: [string, string][] = [];

    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null) continue;

        if (Array.isArray(value)) {
            value.forEach((item) => {
                const stringValue =
                    item instanceof Date ? item.toISOString() : item.toString();
                entries.push([key, stringValue]);
            });
        } else {
            const stringValue =
                value instanceof Date ? value.toISOString() : value.toString();
            entries.push([key, stringValue]);
        }
    }

    return new URLSearchParams(entries).toString();
};

export const createQueryUrl = (baseUrl: string, params?: QueryParams): string =>
    `${baseUrl}?${createQueryString(params)}`;

export const extractBlobData = (
    resp: ApiResponse<Blob>,
    fallbackFilename = 'download'
) => {
    // Extract filename from Content-Disposition header
    const contentDisposition = resp.headers.get('content-disposition');
    let filename = fallbackFilename; // fallback filename

    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
        }
        // Handle filename* (RFC 5987) for UTF-8 encoded filenames
        const filenameStarMatch = contentDisposition.match(
            /filename\*=UTF-8''(.+)/i
        );
        if (filenameStarMatch && filenameStarMatch[1]) {
            filename = decodeURIComponent(filenameStarMatch[1]);
        }
    }

    return {
        data: resp.data,
        filename,
    };
};
